require('./brokerStocksContractStep2.scss');

const PropTypes = require('prop-types');

const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;
// @ components
const DropdownAccounts  = require('components/dropdownAccounts/dropdownAccounts');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');
const {
    BrokerIntervenerList
} = require('components/broker/brokerIntervener/brokerIntervenerList/brokerIntervenerList');
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
// @ constants
const { JOIN_HOLDERS } = require('constants/flagBasedFeatures');
const { SECOND_STEP } = require('constants/index');

class BrokerStocksContractStep2 extends React.Component {
    constructor(props) {
        super(props);
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.buildIntervenerList = this.buildIntervenerList.bind(this);
    }

    buildIntervenerList() {
        const { immStocksContractForm, immAccounts } = this.props;
        const currentInterveners = immStocksContractForm.getIn(['steps', SECOND_STEP, 'interveners']);
        const accountId = immStocksContractForm.getIn(['steps', SECOND_STEP, 'account', 'accountId']);
        const originalInterveners = immAccounts.getIn([accountId, 'interveners']);
        const availableInterveners = immStocksContractForm.getIn([
            'steps',
            SECOND_STEP,
            'availableInterveners'
        ]);

        if (!currentInterveners.isEmpty()) {
            return (
                <BrokerIntervenerList
                    currentInterveners={currentInterveners}
                    availableInterveners={availableInterveners}
                    originalInterveners={originalInterveners}
                />
            );
        }
    }

    buildDisclaimerInfo() {
        const link = formatText('disclaimerPersonalInfo-securitiesGdprDisclaimerLinkUrl');

        return (
            <div className="stocks-contract-step2__disclaimer-personal-info">
                <OKMessage type="informative">
                    <FormattedText value="disclaimerPersonalInfo-securitiesGdprDisclaimerText" />
                    &nbsp;
                    <OKLink to={link} target="_blank">
                        <FormattedText value="disclaimerPersonalInfo-securitiesGdprDisclaimerLinkText" />
                    </OKLink>
                </OKMessage>
            </div>
        );
    }

    handleAccountChange(accountId) {
        this.props.handleAccountChange(accountId);
    }

    render() {
        const {
            immAccounts,
            accountsIndexes,
            accountSelected,
            immStocksContractForm,
            immBlockedAccountsIds,
            isBlockedAccountsLoading
        } = this.props;

        const title = formatText('broker-stocksContractTitle');
        const subTitle = formatText('broker-stocksContractSubTitle');
        const dropdownLabel = formatText('broker-sourceAccountDropdownLabel');
        const errorMsg = formatText('broker-stocksContractSelectAccountMsg');
        const accountError = immStocksContractForm.getIn(['steps', SECOND_STEP, 'accountError']);
        const operative = formatText('operatives-brokerStocksContract');

        return (
            <div className="stocks-contract-step2">
                <header className="stocks-contract-step2__header">
                    <h2 className="stocks-contract-step2__title">
                        {title}
                    </h2>
                </header>
                <ContactCenterRender>
                    <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                </ContactCenterRender>

                <section className="stocks-contract-step2__associated-cc">
                    <header className="stocks-contract-step2__associated-cc-header">
                        <h3 className="stocks-contract-step2__associated-cc-title">
                            {subTitle}
                        </h3>
                    </header>
                    <ContactCenterRender>
                        <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                    </ContactCenterRender>
                    <div className="stocks-contract-step2__associated-cc-stocks-contracts">
                        <DropdownAccounts
                            id="broker-stocks-contracts"
                            immAccounts={immAccounts}
                            accountsIndexes={accountsIndexes.toJS()}
                            currentAccountId={accountSelected}
                            showAvailableBalance={true}
                            onAccountChange={this.handleAccountChange}
                            errorMsg={errorMsg}
                            error={accountError}
                            blockedAccountsIds={immBlockedAccountsIds}
                            label={dropdownLabel}
                            loading={isBlockedAccountsLoading}
                        />
                    </div>
                </section>
                <FeatureTogglingRender notAllowedProductKey={JOIN_HOLDERS} >
                    <section className="stocks-contract-step2__interveners">
                        {this.buildIntervenerList()}
                    </section>
                </FeatureTogglingRender >
                {this.buildDisclaimerInfo()}
            </div>
        );
    }
}

BrokerStocksContractStep2.propTypes = {
    immAccounts: PropTypes.object,
    immStocksContractForm: PropTypes.object,
    accountsIndexes: PropTypes.object,
    accountSelected: PropTypes.string,
    handleAccountChange: PropTypes.func,
    immBlockedAccountsIds: PropTypes.array,
    isBlockedAccountsLoading: PropTypes.bool
};

module.exports = BrokerStocksContractStep2;
